// extracted by mini-css-extract-plugin
export default {"arrow":"Toggle_arrow__nDDTF","up":"Toggle_up__do03f"};